import { SurveySummaryModel } from "..";

export interface SurveySummaryBasicModel {
    surveySummaries: SurveySummaryModel[] | null;
    selectedSurvey: SurveySummaryModel | null;
    hasIncompleteSurveys?: boolean;
    firstIncompleteSurveyMoniker?: string;
    shouldShowSelfRegistration?: boolean;
}
